import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/modules/shared/services/geral/app.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SubSink } from 'subsink';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cadastro-poderes-internos',
  templateUrl: './cadastro-poderes-internos.component.html',
  styleUrls: ['./cadastro-poderes-internos.component.css']
})
export class CadastroPoderesInternosComponent implements OnInit, OnDestroy {

  constructor(public svc: AppService, private activatedRoute: ActivatedRoute, private tl: TranslateService) { }

  public tipo_manutencao_autorizadores: string;
  public tipo_manutencao_seq: string = "I";
  public tipo_manutencao_poder: string = "I";
  public colsAutorizadores: any[];
  public autorizadores: any[];
  public tipos_processo_lista: any[] = [];
  public procuradores_lista: any[];
  public poderes: any[];
  public faixas_erro: boolean = false;
  public faixas_erro_desc: string = "";
  public tipos_processo_erro: boolean = false;
  public tipo_processo_repetido: boolean = false;
  public possui_limite: string = "";
  public valor_inicial: string = "";
  public valor_final: string = "";
  public traducao: any = {
    geral: "",
    tabela_autorizadores: ""
  }
  public nome_sugest: any = [];
  private sub = new SubSink();
  public spinProcesso = true;
  public spinAuto = true;
  public spinAutoCRUD = false;

  public sbRetornarFiltros(lista: any[], column: string): any {
    var retorno = [];

    if (lista) {
      for (let i = 0; i < lista.length; i++) {
        retorno.push(lista[i][column]);
      }

      retorno = retorno.filter(function (value, index) { return retorno.indexOf(value) == index });

      for (let i = 0; i < retorno.length; i++) {
        retorno[i] = { label: retorno[i], value: retorno[i] }
      }
    }

    return retorno;
  }

  public sbAbrirModal(event: Event): void {
    try {
      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  };

  //#region Poderes
  public sequencia_lista = [];

  public nova_sequencia: any = {
    index: -1,
    sequencia: "",
    codigo_autorizador: "",
    nome_autorizador: "",
    codigo_procurador: 0,
    nome_procurador: ""
  };

  public novo_poder: any = {
    processos: [
      {
        id_tipo_processo: -1,
        faixas_limite: [
          {
            id_faixa: -1,
            valor_inicial: this.valor_inicial,
            valor_final: this.valor_final,
            autorizadores: this.sequencia_lista
          }
        ]
      }
    ]
  };

  //Alterar Valor Combo
  public changeProcurador(event) {
    try {
      var novo_text = event.target.item(event.target.selectedIndex).text;
      if (novo_text.toLowerCase() == "selecione") {
        this.nova_sequencia.nome_procurador = "";
        this.nova_sequencia.codigo_procurador = 0;
      } else {
        this.nova_sequencia.nome_procurador = novo_text;
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Alterar Valor Combo
  public changeAutorizador(event) {
    try {
      this.nova_sequencia.nome_autorizador = event.target.item(event.target.selectedIndex).text;
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Alterar Valor Combo
  public changeTipoProcesso(event) {
    try {
      let id_tipo_processo = this.novo_poder.processos[0].id_tipo_processo;

      this.tipos_processo_lista.forEach(item => {
        if (item.id_processo == id_tipo_processo) {
          this.possui_limite = item.limite.toLowerCase();
          return false;
        }
      });

      this.tipo_processo_repetido = false;
      this.tipos_processo_erro = false;
      this.poderes.forEach(item => {
        if (item.id_processo == id_tipo_processo) {
          if (!item.possui_limite) {
            this.tipo_processo_repetido = true;
            this.tipos_processo_erro = true;
            this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.poder_repetido"));
            return false;
          }
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Cancelar
  public cancelarSequencia(f: NgForm) {
    try {
      this.limparFormSeq(f, null);
      this.tipo_manutencao_seq = "I";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Editar
  public editarSequencia(data, f: NgForm) {
    try {
      this.limparFormSeq(f, Object.assign({}, data));
      this.tipo_manutencao_seq = "A";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Escluir
  public excluirSequencia(data, f: NgForm) {
    try {
      this.limparFormSeq(f, Object.assign({}, data));
      this.tipo_manutencao_seq = "E";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public limparFormSeq(f: NgForm, data) {
    f.reset();

    var that = this;
    setTimeout(() => {
      if (data == null) {
        that.nova_sequencia = {
          index: -1,
          sequencia: "",
          codigo_autorizador: "",
          nome_autorizador: "",
          codigo_procurador: 0,
          nome_procurador: ""
        };
      } else {
        that.nova_sequencia = data;
      }
    }, 100);
  }

  public excluir_sequencia(f: NgForm) {
    try {
      this.sequencia_lista.forEach((item, index) => {
        if (item.index == this.nova_sequencia.index) {
          this.sequencia_lista.splice(index, 1);
          return false;
        }
      });

      //reseta a sequência
      this.sequencia_lista.forEach((item, index) => {
        this.sequencia_lista[index].index = index;
      });

      this.limparFormSeq(f, null);
      this.tipo_manutencao_seq = "I";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public salvar_sequencia(f: NgForm) {
    try {
      //Verifica se o Formulário está Válido
      if (f.valid) {
        let fl_existe: boolean = false;
        let indice: number = -1;
        this.sequencia_lista.forEach(item => {
          if (item.index != this.nova_sequencia.index) {
            if (item.codigo_autorizador == this.nova_sequencia.codigo_autorizador) {
              fl_existe = true;
              return false;
            }
          }
        });

        if (fl_existe) {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.autorizador_repetido"));
        } else {
          this.sequencia_lista.forEach((item, index) => {
            if (item.index == this.nova_sequencia.index) {
              this.sequencia_lista[index] = Object.assign({}, this.nova_sequencia);
              return false;
            }
          });

          this.limparFormSeq(f, null);
          this.tipo_manutencao_seq = "I";
        }
      } else {
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public adicionar_sequencia(f: NgForm) {
    try {
      this.tipo_manutencao_seq = "I";
      //Verifica se o Formulário está Válido
      if (f.valid) {
        let fl_existe: boolean = false;
        this.sequencia_lista.forEach(item => {
          if (item.codigo_autorizador == this.nova_sequencia.codigo_autorizador) {
            fl_existe = true;
            return false;
          }
        });

        if (fl_existe) {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.autorizador_repetido"));
        } else {
          this.nova_sequencia.index = this.sequencia_lista.length;
          this.sequencia_lista.push(Object.assign({}, this.nova_sequencia));
          this.limparFormSeq(f, null);
        }
      } else {
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public limparCamposPoder(f: NgForm) {
    try {
      this.sequencia_lista = [];
      this.limparFormSeq(f, null);
      this.tipo_manutencao_poder = "I";
      this.tipo_manutencao_seq = "I"
      this.valor_inicial = "";
      this.valor_final = "";
      this.faixas_erro = false;
      this.faixas_erro_desc = "";
      this.tipos_processo_erro = false;
      this.possui_limite = "não";
      this.novo_poder = {
        processos: [
          {
            id_tipo_processo: -1,
            faixas_limite: [
              {
                id_faixa: -1,
                valor_inicial: this.valor_inicial,
                valor_final: this.valor_final,
                autorizadores: this.sequencia_lista
              }
            ]
          }
        ]
      };
    } catch (e) {
      throw e;
    }
  }

  public fnValidarPoder(): boolean {
    try {
      let fl_valido = true;
      this.tipos_processo_erro = false;
      this.faixas_erro = false;
      this.faixas_erro_desc = "";

      if (this.novo_poder.processos[0].id_tipo_processo == -1) {
        fl_valido = false;
        this.tipos_processo_erro = true;
      }

      if (this.possui_limite.toLowerCase() == "sim") {
        if (this.valor_inicial == "" || this.valor_final == "") {
          fl_valido = false;
          this.faixas_erro = true
          this.faixas_erro_desc = this.tl.instant("cadastro_poderes.mensagens.informe_limite");
        } else {
          var vl_inicial = parseInt(this.svc.fnRemoverMascara(this.valor_inicial)) / 100;
          var vl_final = parseInt(this.svc.fnRemoverMascara(this.valor_final)) / 100;
          if (vl_final < vl_inicial) {
            fl_valido = false;
            this.faixas_erro = true
            this.faixas_erro_desc = this.tl.instant("cadastro_poderes.mensagens.limite_invalido");
          }
        }
      }

      if (this.tipo_manutencao_poder == "I") {
        if (this.tipo_processo_repetido) {
          this.tipos_processo_erro = true;
          fl_valido = false;
        }
      }

      if (this.sequencia_lista.length == 0) {
        fl_valido = false;
      }

      if (!fl_valido) {
        if (this.sequencia_lista.length == 0) {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.informe_sequencia"));
        } else if (this.tipo_processo_repetido && this.tipo_manutencao_poder == "I") {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.poder_repetido"));
        } else {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("geral.mensagens.campos_vermelho"));
        }
      }

      return fl_valido;
    } catch (e) {
      throw e;
    }
  }

  //salvar poder
  public processarPoder() {
    try {
      var limite_valido = true;
      if (this.fnValidarPoder()) {
        if (this.possui_limite == "sim") {
          this.novo_poder.processos[0].faixas_limite[0].valor_inicial = parseInt(this.svc.fnRemoverMascara(this.valor_inicial));
          this.novo_poder.processos[0].faixas_limite[0].valor_final = parseInt(this.svc.fnRemoverMascara(this.valor_final));
        } else {
          this.novo_poder.processos[0].faixas_limite[0].valor_inicial = parseInt("0");
          this.novo_poder.processos[0].faixas_limite[0].valor_final = parseInt("0");
        }
        var valor_inicial = this.novo_poder.processos[0].faixas_limite[0].valor_inicial;
        var valor_final = this.novo_poder.processos[0].faixas_limite[0].valor_final;
        if (this.possui_limite == "sim" && valor_inicial == valor_final) {
          var limite_valido = false;
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), "O valor inicial não pode ser igual ao valor final!");
        }

        if (limite_valido) {
          if (this.tipo_manutencao_poder == "I") {
            this.svc.InserirProcessosPoderesInternos(this.novo_poder);
            this.sub.sink = this.svc.ProcessosPoderesInternosIncluido().subscribe((resp) => {
              if (resp != null) {
                this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.poder_incluido"));
                this.carregarPoderes();
                this.svc.sbFecharModal("modalPoderes");
              }
            });
          } else {
            this.svc.AlterarProcessosPoderesInternos(this.novo_poder);
            this.sub.sink = this.svc.ProcessosPoderesInternosAlterado().subscribe((resp) => {
              if (resp != null) {
                this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.poder_alterado"));
                this.carregarPoderes();
                this.svc.sbFecharModal("modalPoderes");
              }
            });
          }
        }
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //excluir poder
  public excluirPoder() {
    try {
      this.svc.DeletarProcessosPoderesInternos({
        id_faixa: parseInt(this.novo_poder.processos[0].faixas_limite[0].id_faixa)
      });
      this.sub.sink = this.svc.ProcessosPoderesInternosExcluido().subscribe((resp) => {
        if (resp != null) {
          this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.poder_excluido"));
          this.carregarPoderes();
          this.svc.sbFecharModal("modalPoderes");
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Inserir
  public adicionarFaixa(f: NgForm) {
    try {
      this.limparCamposPoder(f);
      this.svc.sbAbrirModal("modalPoderes");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Editar
  public editarFaixa(faixa, processo, f: NgForm) {
    try {
      this.limparCamposPoder(f);
      this.possui_limite = Object.assign({}, processo).possui_limite ? "sim" : "false";
      this.valor_inicial = Object.assign({}, faixa).valor_inicial;
      this.valor_final = Object.assign({}, faixa).valor_final;
      faixa.autorizadores.forEach((item, index) => {
        this.sequencia_lista.push(Object.assign({}, item));
        this.sequencia_lista[index].index = index;
      });
      this.novo_poder = {
        processos: [
          {
            id_tipo_processo: Object.assign({}, processo).id_processo,
            faixas_limite: [
              {
                id_faixa: Object.assign({}, faixa).id_faixa,
                valor_inicial: this.valor_inicial,
                valor_final: this.valor_final,
                autorizadores: this.sequencia_lista
              }
            ]
          }
        ]
      };
      this.tipo_manutencao_poder = "A";
      this.svc.sbAbrirModal("modalPoderes");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public excluirFaixa(faixa, processo, f: NgForm) {
    try {
      this.limparCamposPoder(f);
      this.possui_limite = Object.assign({}, processo).possui_limite ? "sim" : "false";
      this.valor_inicial = Object.assign({}, faixa).valor_inicial;
      this.valor_final = Object.assign({}, faixa).valor_final;
      faixa.autorizadores.forEach((item, index) => {
        this.sequencia_lista.push(Object.assign({}, item));
        this.sequencia_lista[index].index = index;
      });
      this.novo_poder = {
        processos: [
          {
            id_tipo_processo: Object.assign({}, processo).id_processo,
            faixas_limite: [
              {
                id_faixa: Object.assign({}, faixa).id_faixa,
                valor_inicial: this.valor_inicial,
                valor_final: this.valor_final,
                autorizadores: this.sequencia_lista
              }
            ]
          }
        ]
      };
      this.tipo_manutencao_poder = "E";
      this.svc.sbAbrirModal("modalPoderes");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Carregar Dados
  public carregarPoderes() {
    try {
      this.spinProcesso = true;
      this.svc.CadastroPoderesInternosPesquisar();
      this.sub.sink = this.svc.CadastroPoderesInternos().subscribe((resp: any) => {
        if (resp != null) {
          this.spinProcesso = false;
          this.poderes = resp.processos;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  //Carregar Dados
  public carregarTiposProcesso() {
    try {
      this.svc.TipoProcessoPesquisar();
      this.sub.sink = this.svc.TipoProcesso().subscribe((resp: any) => {
        if (resp != null)
          this.tipos_processo_lista = resp.Processos;
      });
    } catch (e) {
      throw e;
    }
  }
  //#endregion

  //#region Autorizadores
  public novo_autorizador: any = {
    id_autorizador: -1,
    cd_usuario: -1,
    nome_autorizador: "",
    documento: "",
    email_principal: "",
    email_aviso: "",
    cargo: "",
    celular: "",
    procurador: false,
    ind_autorizador_master: false
  };

  public limparFormAutorizador(f: NgForm, data) {
    f.reset();

    var that = this;
    setTimeout(() => {
      if (data == null) {
        that.novo_autorizador = {
          id_autorizador: -1,
          cd_usuario: -1,
          nome_autorizador: "",
          documento: "",
          email_principal: "",
          email_aviso: "",
          cargo: "",
          celular: "",
          procurador: false,
          ind_autorizador_master: false
        };
      } else {
        that.novo_autorizador = data;
      }
    }, 100);
  }

  public selecionarNome(event) {
    try {
      this.novo_autorizador.nome_autorizador = event.nm_usuario;
      this.novo_autorizador.cargo = event.ds_cargo;
      this.novo_autorizador.documento = event.nr_cpf;
      this.novo_autorizador.cd_usuario = event.cd_usuario;
      this.novo_autorizador.email_principal = event.ds_email;
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public buscarUsuarios(event) {
    try {
      this.svc.CadastroUsuariosCorpPesquisar(event.query);
      this.sub.sink = this.svc.CadastroUsuariosCorp().subscribe((resp) => {
        if (resp != null) {
          this.nome_sugest = resp;
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Processar Dados
  public salvarAutorizador(f: NgForm) {
    try {
      //Verifica se o FOrmulário está Válido
      if (f.valid) {
        if (this.tipo_manutencao_autorizadores == "I") {
          this.spinAutoCRUD = true;
          this.svc.InserirAutorizadorInterno(this.novo_autorizador);
          this.sub.sink = this.svc.AutorizadorInternoIncluido().subscribe((resp) => {
            if (resp == false) this.spinAutoCRUD = false;
            else if (resp != null) {
              this.spinAutoCRUD = false;
              this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.autorizador_incluido"));
              this.carregarAutorizadores();
            }
          });
        } else {
          this.spinAutoCRUD = true;
          this.svc.AlterarAutorizadorInterno(this.novo_autorizador);
          this.sub.sink = this.svc.AutorizadorInternoAlterado().subscribe((resp) => {
            if (resp == false) this.spinAutoCRUD = false;
            else if (resp != null) {
              this.spinAutoCRUD = false;
              this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.autorizador_alterado"));
              this.carregarAutorizadores();
            }
          });
        }
        this.svc.sbFecharModal("modalAutorizadoresCRUD");
      } else {
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("geral.mensagens.campos_obrigatorios"));
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Processar Dados
  public excluirAutorizador() {
    try {
      this.spinAutoCRUD = true;
      this.svc.ExcluirAutorizadorInterno(this.novo_autorizador);
      this.sub.sink = this.svc.AutorizadorInternoExcluido().subscribe((resp) => {
        if (resp == false) this.spinAutoCRUD = false;
        else if (resp != null) {
          this.spinAutoCRUD = false;
          this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.autorizador_excluido"));
          this.carregarAutorizadores();
        }
      });
      this.svc.sbFecharModal("modalAutorizadoresCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Carregar Procuradores
  public carregarProcuradores() {
    try {
      this.svc.ProcuradoresInternosPesquisar();
      this.sub.sink = this.svc.CadastroProcuradoresInternos().subscribe((resp) => {
        if (resp != null) {
          this.procuradores_lista = resp;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  //Carregar Dados
  public carregarAutorizadores() {
    try {
      this.spinAuto = true;
      this.carregarProcuradores();
      this.svc.AutorizadoresInternosPesquisar();
      this.sub.sink = this.svc.CadastroAutorizadoresInternos().subscribe((resp) => {
        if (resp != null) {
          this.spinAuto = false;
          this.autorizadores = resp;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  //Criar
  public adicionarAutorizador(f: NgForm) {
    try {
      this.limparFormAutorizador(f, null);
      this.tipo_manutencao_autorizadores = "I";
      this.svc.sbAbrirModal("modalAutorizadoresCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Remover
  public removerAutorizador(data, f: NgForm) {
    try {
      this.limparFormAutorizador(f, Object.assign({}, data));
      this.tipo_manutencao_autorizadores = "E";
      this.svc.sbAbrirModal("modalAutorizadoresCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Editar
  public editarAutorizador(data, f: NgForm) {
    try {
      this.limparFormAutorizador(f, Object.assign({}, data));
      this.tipo_manutencao_autorizadores = "A";
      this.svc.sbAbrirModal("modalAutorizadoresCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public sbCarregarIdiomaTBAutorizadores() {
    this.colsAutorizadores = [
      { type: 'edit', filter: false, filter_type: 'multi-select', header: '', field: 'id_autorizador', size: '3%', text_align: 'text-right' },
      { type: 'remove', filter: false, filter_type: 'multi-select', header: '', field: 'id_autorizador', size: '3%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.nome"), field: 'nome_autorizador', size: '18%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.documento"), field: 'documento', size: '12%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.email_principal"), field: 'email_principal', size: '15%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.email_aviso"), field: 'email_aviso', size: '15%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.papel"), field: 'cargo', size: '12%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.celular"), field: 'celular', size: '12%', text_align: 'text-left' },
      { type: 'checkbox', filter: true, filter_type: 'multi-select', header: 'Master', field: 'ind_autorizador_master', size: '10%', text_align: 'text-center' }
    ];
  }
  //#endregion

  ngOnInit() {
    try {
      this.carregarTiposProcesso();
      this.carregarAutorizadores();
      this.carregarPoderes();

      //É chamado sempre que o Idioma for Mudado
      this.sub.sink = this.svc.sbGetTraducaoAuto("cadastro_poderes.autorizadores_tabela").subscribe((resp) => {
        this.sbCarregarIdiomaTBAutorizadores();
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}
